import React from 'react';
import PropTypes from 'prop-types';
import JarvisWidget from './JarvisWidget.jsx'

export default class Widget extends React.Component{

  constructor(props) {
    super(props);

    this.state = {
      isActivityUser: this.props.isActivityUser
    };
  }

  onActivityUserChange(event) {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState({
      isActivityUser: value
    });

    this.props.handleActivityUserChange(value);
  }

  render() {
    let {children, title, props} = {...this.props};
    return (<div {...props}>
              <JarvisWidget editbutton={false} color="blueDark">
                  <header>
                      <span className="widget-icon"> <i className="fa fa-table"/> </span>
                      <h2>{title}</h2>
                        <div className="widget-toolbar hidden-mobile">
                          <span className="onoffswitch-title">Installed User</span>
                          <span className="onoffswitch">
                              <input type="checkbox" name="isActivityUser" className="onoffswitch-checkbox"
                                    id="myonoffswitch"
                                      checked={this.state.isActivityUser}
                                      onChange={this.onActivityUserChange.bind(this)}
                                      />
                                  <label className="onoffswitch-label" htmlFor="myonoffswitch"> <span
                                      className="onoffswitch-inner" data-swchon-text="YES"
                                      data-swchoff-text="NO"/> <span
                                      className="onoffswitch-switch"/> </label>
                          </span>
                        </div>
                  </header>
                  <div>
                      <div className="widget-body no-padding">
                          {children}
                      </div>
                  </div>
              </JarvisWidget>
            </div>);
  }
}

Widget.PropTypes = {
  title: PropTypes.string.isRequired,
  handleActivityUserChange: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/layout/widgets/SCWidget.jsx